import React from 'react';

interface Fill {
  fill: string;
}
export const HomeHeaderIcon = ({ fill }: Fill) => (
  <div
    style={{
      width: '18px',
      height: '18px',
      justifyContent: 'center',
      alignContent: 'center',
      borderColor: 'black',
    }}
  >
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.704238 8.2258L0.704843 8.2252L8.40803 0.525746C8.40813 0.525639 8.40824 0.525532 8.40835 0.525425C8.42492 0.509136 8.44723 0.5 8.47048 0.5C8.49371 0.5 8.51602 0.509127 8.53258 0.525405C8.5327 0.525519 8.53281 0.525633 8.53293 0.525747L16.236 8.22511C16.236 8.22513 16.2361 8.22515 16.2361 8.22518C16.3692 8.35828 16.4409 8.53223 16.4409 8.71617L16.4409 8.71818C16.4411 8.77804 16.4335 8.83755 16.4185 8.89521L15.7378 8.2149L8.8258 1.30666L8.47239 0.953437L8.11893 1.30661L1.20509 8.21485L0.52389 8.89549C0.508955 8.84094 0.50071 8.78394 0.500045 8.72544L0.500045 8.72542C0.498989 8.63273 0.516514 8.54076 0.551584 8.45495C0.586655 8.36914 0.638561 8.29122 0.704238 8.2258ZM15.3843 9.06855H16.3467C16.3168 9.11955 16.2805 9.16662 16.2385 9.20852L16.2379 9.20909C16.1051 9.3419 15.9312 9.41394 15.745 9.41394H14.934H14.434V9.91394V15.5H2.50696V9.91394V9.41394H2.00696H1.2128C0.950124 9.41394 0.721841 9.27369 0.598203 9.06855H1.5585H2.85236V14.6546V15.1546H3.35236H6.22815H6.72815V14.6546V10.3942C6.72815 10.2574 6.83877 10.1467 6.97559 10.1467H9.96536C10.1022 10.1467 10.2128 10.2574 10.2128 10.3942V14.6546V15.1546H10.7128H13.5886H14.0886V14.6546V9.06855H15.3843ZM9.5169 15.1546H10.0169V14.6546V10.8426V10.3426H9.5169H7.42406H6.92406V10.8426V14.6546V15.1546H7.42406H9.5169Z"
        fill={fill}
        stroke={fill}
      />
    </svg>
  </div>
);

export const DashboardsHeaderIcon = ({ fill }: Fill) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.05591C12 0.503623 12.4477 0.0559082 13 0.0559082H16C16.5523 0.0559082 17 0.503623 17 1.05591V14.0559C17 14.6082 16.5523 15.0559 16 15.0559H13C12.4477 15.0559 12 14.6082 12 14.0559V1.05591Z"
      fill={fill}
    />
    <path
      d="M6 7.05591C6 6.50362 6.44772 6.05591 7 6.05591H10C10.5523 6.05591 11 6.50362 11 7.05591V14.0559C11 14.6082 10.5523 15.0559 10 15.0559H7C6.44772 15.0559 6 14.6082 6 14.0559V7.05591Z"
      fill={fill}
    />
    <path
      d="M0 1.05591C0 0.503623 0.447715 0.0559082 1 0.0559082H4C4.55228 0.0559082 5 0.503623 5 1.05591V8.05591C5 8.60819 4.55228 9.05591 4 9.05591H1C0.447715 9.05591 0 8.60819 0 8.05591V1.05591Z"
      fill={fill}
    />
    <path
      d="M6 1.05591C6 0.503623 6.44772 0.0559082 7 0.0559082H10C10.5523 0.0559082 11 0.503623 11 1.05591V4.05591C11 4.60819 10.5523 5.05591 10 5.05591H7C6.44772 5.05591 6 4.60819 6 4.05591V1.05591Z"
      fill={fill}
    />
    <path
      d="M0 11.0559C0 10.5036 0.447715 10.0559 1 10.0559H4C4.55228 10.0559 5 10.5036 5 11.0559V14.0559C5 14.6082 4.55228 15.0559 4 15.0559H1C0.447715 15.0559 0 14.6082 0 14.0559V11.0559Z"
      fill={fill}
    />
  </svg>
);
export const GraphsHeaderIcon = ({ fill }: Fill) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.57812 11.2122V11.2278H1.59375H16.4688C16.7536 11.2278 16.9844 11.4585 16.9844 11.7434V12.2747C16.9844 12.5595 16.7536 12.7903 16.4688 12.7903H1.0625C0.48443 12.7903 0.015625 12.3215 0.015625 11.7434V0.587158C0.015625 0.302272 0.246364 0.0715332 0.53125 0.0715332H1.0625C1.34739 0.0715332 1.57812 0.302272 1.57812 0.587158V11.2122ZM13.9188 9.60278H13.175C13.0738 9.60278 12.9714 9.55204 12.8939 9.47455C12.8164 9.39705 12.7656 9.29458 12.7656 9.19341V1.54341C12.7656 1.44224 12.8164 1.33976 12.8939 1.26227C12.9714 1.18477 13.0738 1.13403 13.175 1.13403H13.9188C14.0199 1.13403 14.1224 1.18477 14.1999 1.26227C14.2774 1.33976 14.3281 1.44224 14.3281 1.54341V9.19341C14.3281 9.29458 14.2774 9.39705 14.1999 9.47455C14.1224 9.55204 14.0199 9.60278 13.9188 9.60278ZM7.54375 9.60278H6.8C6.69883 9.60278 6.59636 9.55204 6.51886 9.47455C6.44137 9.39705 6.39062 9.29458 6.39062 9.19341V2.60591C6.39062 2.50474 6.44137 2.40226 6.51886 2.32477C6.59636 2.24727 6.69883 2.19653 6.8 2.19653H7.54375C7.64492 2.19653 7.74739 2.24727 7.82489 2.32477C7.90238 2.40226 7.95312 2.50474 7.95312 2.60591V9.19341C7.95312 9.29458 7.90238 9.39705 7.82489 9.47455C7.74739 9.55204 7.64492 9.60278 7.54375 9.60278ZM10.7313 9.60278H9.9875C9.88633 9.60278 9.78386 9.55204 9.70636 9.47455C9.62887 9.39705 9.57812 9.29458 9.57812 9.19341V4.73091C9.57812 4.62974 9.62887 4.52726 9.70636 4.44977C9.78386 4.37227 9.88633 4.32153 9.9875 4.32153H10.7313C10.8324 4.32153 10.9349 4.37227 11.0124 4.44977C11.0899 4.52726 11.1406 4.62974 11.1406 4.73091V9.19341C11.1406 9.29458 11.0899 9.39705 11.0124 9.47455C10.9349 9.55204 10.8324 9.60278 10.7313 9.60278ZM4.35625 9.60278H3.6125C3.51133 9.60278 3.40886 9.55204 3.33136 9.47455C3.25387 9.39705 3.20312 9.29458 3.20312 9.19341V6.85591C3.20312 6.75474 3.25387 6.65226 3.33136 6.57477C3.40886 6.49727 3.51133 6.44653 3.6125 6.44653H4.35625C4.45742 6.44653 4.55989 6.49727 4.63739 6.57477C4.71488 6.65226 4.76562 6.75474 4.76562 6.85591V9.19341C4.76562 9.29458 4.71488 9.39705 4.63739 9.47455C4.55989 9.55204 4.45742 9.60278 4.35625 9.60278Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.03125"
    />
  </svg>
);
export const UsersHeaderIcon = ({ fill }: Fill) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 13.1864L0.5 13.1868C0.501047 12.0938 0.816871 11.0242 1.40971 10.106C2.00255 9.18769 2.84732 8.4596 3.84301 8.00873L4.55465 7.68648L3.96399 7.17521C3.60535 6.86476 3.31768 6.4808 3.12053 6.04937C2.92337 5.61794 2.82133 5.14915 2.82133 4.6748V4.6748C2.82133 3.78131 3.17627 2.92442 3.80806 2.29263C4.43985 1.66084 5.29674 1.30591 6.19022 1.30591C7.08371 1.30591 7.9406 1.66084 8.57239 2.29263L8.91732 1.9477L8.57239 2.29263C9.20418 2.92442 9.55911 3.78131 9.55911 4.6748C9.55912 5.14915 9.45708 5.61794 9.25992 6.04937C9.06276 6.4808 8.7751 6.86476 8.41646 7.17521L7.8258 7.68648L8.53744 8.00873C9.53313 8.4596 10.3779 9.18769 10.9707 10.106C11.5636 11.0242 11.8794 12.0938 11.8804 13.1868L12.3804 13.1864H11.8804C11.8804 13.259 11.8516 13.3286 11.8003 13.3799L12.1538 13.7335L11.8003 13.3799C11.7489 13.4313 11.6793 13.4601 11.6067 13.4601C11.5341 13.4601 11.4644 13.4313 11.4131 13.3799C11.3617 13.3286 11.3329 13.259 11.3329 13.1864C11.3329 11.8224 10.7911 10.5144 9.82664 9.54994C8.8622 8.5855 7.55414 8.04369 6.19022 8.04369C4.8263 8.04369 3.51825 8.5855 2.55381 9.54994C1.58937 10.5144 1.04756 11.8224 1.04756 13.1864C1.04756 13.259 1.01871 13.3286 0.967369 13.3799C0.916025 13.4313 0.84639 13.4601 0.773778 13.4601C0.701166 13.4601 0.63153 13.4313 0.580188 13.3799C0.528845 13.3286 0.5 13.259 0.5 13.1864H0ZM0 13.1864C0.00113889 11.9973 0.344714 10.8337 0.989647 9.83477C1.53752 8.98616 2.28316 8.28684 3.15923 7.79488M0 13.1864L3.15923 7.79488M3.15923 7.79488C3.20819 7.84147 3.2583 7.88696 3.30952 7.93129L3.63676 7.55325L3.43051 7.09777C3.37322 7.12371 3.31635 7.15044 3.25993 7.17793C3.01911 6.90197 2.81876 6.592 2.66576 6.25719C2.43879 5.76053 2.32133 5.22086 2.32133 4.6748C2.32133 3.6487 2.72895 2.66464 3.45451 1.93908C4.18006 1.21352 5.16413 0.805908 6.19022 0.805908C7.21632 0.805908 8.20038 1.21352 8.92594 1.93908C9.6515 2.66464 10.0591 3.6487 10.0591 4.6748C10.0591 5.22086 9.94165 5.76053 9.71469 6.25719C9.56168 6.592 9.36133 6.90197 9.12052 7.17793L3.15923 7.79488ZM9.07093 7.93129C9.12215 7.88696 9.17225 7.84147 9.22122 7.79488L8.74369 7.55325L9.07093 7.93129ZM13.353 6.91174L12.9601 7.35416L13.4618 7.66774C14.3965 8.25188 15.1663 9.06531 15.698 10.0307C16.2297 10.9962 16.5058 12.0815 16.4999 13.1837V13.1864C16.4999 13.259 16.4711 13.3286 16.4197 13.3799C16.3684 13.4313 16.2987 13.4601 16.2261 13.4601C16.1535 13.4601 16.0839 13.4313 16.0325 13.3799C15.9815 13.3289 15.9527 13.2599 15.9523 13.1878C15.9608 12.0611 15.6473 10.9554 15.0488 10.0008C14.4521 9.0491 13.5969 8.28701 12.5833 7.8035L12.5144 7.76641L12.2322 7.57828L12.2322 7.57827L12.2297 7.57662C12.1909 7.55106 12.1592 7.51604 12.1376 7.47485C12.1162 7.43379 12.1054 7.38795 12.1065 7.34162C12.1078 7.2949 12.121 7.24928 12.1449 7.20911C12.1689 7.16885 12.2028 7.13541 12.2434 7.11199L12.2436 7.1119C12.6713 6.86492 13.0268 6.50995 13.2743 6.08251L12.8417 5.83192L13.2743 6.08251C13.5219 5.65506 13.6529 5.1701 13.6542 4.67614V4.6748C13.6542 3.92653 13.357 3.20892 12.8279 2.67981C12.2988 2.15071 11.5812 1.85346 10.8329 1.85346C10.7603 1.85346 10.6906 1.82462 10.6393 1.77328C10.588 1.72193 10.5591 1.6523 10.5591 1.57969C10.5591 1.50708 10.588 1.43744 10.6393 1.3861C10.6906 1.33475 10.7603 1.30591 10.8329 1.30591L10.833 1.30591C11.4824 1.30573 12.118 1.49325 12.6633 1.84589L12.9348 1.42603L12.6633 1.84589C13.2086 2.19853 13.6404 2.70125 13.9066 3.29355C14.1729 3.88585 14.2623 4.54248 14.1641 5.1844C14.0658 5.82632 13.7842 6.42617 13.353 6.91174ZM4.62277 7.02065C5.08674 7.33066 5.63222 7.49613 6.19022 7.49613C6.93849 7.49613 7.65611 7.19889 8.18521 6.66978C8.71431 6.14068 9.01156 5.42306 9.01156 4.6748C9.01156 4.11679 8.84609 3.57131 8.53608 3.10735C8.22606 2.64338 7.78543 2.28177 7.2699 2.06823C6.75437 1.85469 6.18709 1.79881 5.63981 1.90768C5.09252 2.01654 4.58981 2.28524 4.19524 2.67981C3.80067 3.07438 3.53196 3.5771 3.4231 4.12438C3.31424 4.67167 3.37011 5.23894 3.58365 5.75448C3.79719 6.27001 4.15881 6.71064 4.62277 7.02065Z"
      fill={fill}
      stroke={fill}
    />
  </svg>
);
export const FiltersHeaderIcon = ({ fill }: Fill) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1.96008H18L11.2 11.1029V17.9601H7.8V11.1029L1 1.96008Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SettingsHeaderIcon = ({ fill }: Fill) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.53333 1.96008H13.4667L18 9.32675L13.4667 16.6934H5.53333L1 9.32675L5.53333 1.96008Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 12.1601C11.0648 12.1601 12.3333 10.8916 12.3333 9.32675C12.3333 7.76194 11.0648 6.49342 9.5 6.49342C7.93519 6.49342 6.66667 7.76194 6.66667 9.32675C6.66667 10.8916 7.93519 12.1601 9.5 12.1601Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
